import { client } from "@/api/client";
import interceptors from "@/api/interceptor";
import qs from "qs";

client.interceptors.request.use(interceptors.auth, interceptors.onError);

function getProduct(params) {
	return client.get("seller/product/data", {
		params: params,
	});
}

function getProductInternal(params) {
	return client.get("seller/product/data-internal", {
		params: params,
	});
}

function getProductDetail(params) {
	return client.get("seller/product/detail", {
		params: params,
	});
}

function addProduct(params) {
	return client.post("seller/product/add", qs.stringify(params), {
		header: {
			"Content-Type": "application/x-www-form-urlencoded"
		}
	});
}

function updateProduct(params) {
	return client.post("seller/product/edit", qs.stringify(params), {
		header: {
			"Content-Type": "application/x-www-form-urlencoded"
		}
	});
}

function statusProduct(params) {
	return client.post("seller/product/status", qs.stringify(params), {
		header: {
			"Content-Type": "application/x-www-form-urlencoded"
		}
	});
}

function removeProduct(params) {
	return client.post("seller/product/delete", qs.stringify(params), {
		header: {
			"Content-Type": "application/x-www-form-urlencoded"
		}
	});
}

function removeProductImage(params) {
	return client.post("seller/product/delete-image", qs.stringify(params), {
		header: {
			"Content-Type": "application/x-www-form-urlencoded"
		}
	});
}

function uploadImage(params) {
	return client.post("seller/product/upload-image", params, {
		header: {
			'Content-Type': 'multipart/form-data'
		}
	});
}

export default {
	getProduct,
	getProductInternal,
	getProductDetail,
	addProduct,
	updateProduct,
	statusProduct,
	removeProduct,
	removeProductImage,
	uploadImage,
};